export default __webpack_public_path__ + "static/media/Ability_Hydrosophist.502cc140.png";